<template>
  <table class="grid-selector">
    <tr v-for="rowOfGeneralHands in gridOfGeneralHands">
      <grid-square
        v-for="generalHand in rowOfGeneralHands"
        v-bind:key="generalHand.string"
        v-bind:generalHand="generalHand"
        v-bind:clickAndDragContext="clickAndDragContext"
        v-bind:altKeyPressed="altKeyPressed"
        v-bind:disabled="disabled"
        v-bind:specificHandsNotAllowed="specificHandsNotAllowed"
        v-bind:equityMatrix="equityMatrix"
        v-bind:requiredEquity="requiredEquity"
        v-bind:rangeConstructor="rangeConstructor"
        v-on:selectGeneralHand="selectGeneralHand($event)"
        v-on:deselectGeneralHand="deselectGeneralHand($event)"
        v-on:selectAscendingGeneralHands="selectAscendingGeneralHands($event)"
        v-on:deselectAscendingGeneralHands="deselectAscendingGeneralHands($event)"
        v-on:selectSpecificHand="$emit('selectSpecificHand', $event)"
        v-on:deselectSpecificHand="$emit('deselectSpecificHand', $event)"
        v-on:setSpecificHandAsManuallySet="$emit('setSpecificHandAsManuallySet', $event)"
        v-on:setSpecificHandAsNotManuallySet="$emit('setSpecificHandAsNotManuallySet', $event)"
        v-on:applyExactWeightToGeneralHand="$emit('applyExactWeightToGeneralHand', $event)"
        v-on:setWeightOfSpecificHand="$emit('setWeightOfSpecificHand', $event)"
      />
    </tr>
  </table>
</template>

<script>
import GridSquare from '@/components/hand-range/grid-selector/grid-square';
import utilities from '@/services/utilities/utilities';
import constants from '@/services/constants';

export default {
  name: 'grid-selector',
  components: {
    'grid-square': GridSquare,
  },
  props: ['generalHands', 'disabled', 'specificHandsNotAllowed', 'equityMatrix', 'requiredEquity', 'rangeConstructor'],
  data: function () {
    let self = this;
    let data = {
      clickAndDragContext: null,
      altKeyPressed: false,
    };

    $('body').on('mouseup', function () {
      if (self.$data && (self.$data.clickAndDragContext === 'adding' || self.$data.clickAndDragContext === 'removing')) {
        self.$emit('finishedClickAndDrag');
        self.$set(data, 'clickAndDragContext', null);
      }
    });

    $('body').keydown(function(event) {
      if (event.altKey) {
        self.$set(data, 'altKeyPressed', true);
      }
    }).keyup(function(event) {
      self.$set(data, 'altKeyPressed', false);
    });

    return data;
  },
  computed: {
    gridOfGeneralHands: function () {
      return constants.gridOfGeneralHandStrings.map(function (rowOfGeneralHandStrings) {
        return this._getRowOfGeneralHands(rowOfGeneralHandStrings, this.generalHands);
      }, this);
    },
  },
  methods: {
    _getRowOfGeneralHands: function (rowOfGeneralHandStrings, generalHands) {
      return rowOfGeneralHandStrings.map(function (generalHandString) {
        return generalHands.find(generalHandString);
      });
    },
    selectGeneralHand: function (generalHandString) {
      this.$emit('selectGeneralHand', generalHandString);
      this.clickAndDragContext = 'adding';
    },
    deselectGeneralHand: function (generalHandString) {
      this.$emit('deselectGeneralHand', generalHandString);
      this.clickAndDragContext = 'removing';
    },
    selectAscendingGeneralHands: function (generalHandStringOfGridSquareThatWasClicked) {
      let ascendingGeneralHandStrings = utilities.hands.getAscendingGeneralHandStrings(generalHandStringOfGridSquareThatWasClicked);

      this.$emit('selectGeneralHands', ascendingGeneralHandStrings);
    },
    deselectAscendingGeneralHands: function (generalHandStringOfGridSquareThatWasClicked) {
      let ascendingGeneralHandStrings = utilities.hands.getAscendingGeneralHandStrings(generalHandStringOfGridSquareThatWasClicked);

      this.$emit('deselectGeneralHands', ascendingGeneralHandStrings);
    },
  },
};
</script>

<style lang="scss" scoped>
  table {
    border-spacing: 2px;
    border-collapse: separate;
    max-width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/hand-range/grid-selector/grid-selector.vue